var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividendsReinvested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_47088)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3,
    r: 1.5,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C1 8.567 2.567 7 4.5 7V7C6.433 7 8 8.567 8 10.5V10.75H1V10.5Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5813 19.6048C22.8577 18.9375 23 18.2223 23 17.5C23 16.0413 22.4205 14.6424 21.3891 13.6109C20.3576 12.5795 18.9587 12 17.5 12C16.0413 12 14.6424 12.5795 13.6109 13.6109C12.5795 14.6424 12 16.0413 12 17.5C12 18.2223 12.1423 18.9375 12.4187 19.6048C12.6951 20.272 13.1002 20.8784 13.6109 21.3891C14.1216 21.8998 14.728 22.3049 15.3952 22.5813C16.0625 22.8577 16.7777 23 17.5 23C18.2223 23 18.9375 22.8577 19.6048 22.5813C20.272 22.3049 20.8784 21.8998 21.3891 21.3891C21.8998 20.8784 22.3049 20.272 22.5813 19.6048Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.2083C16.5334 15.2083 15.75 15.7304 15.75 16.375C15.75 17.0196 16.5334 17.5417 17.5 17.5417C18.4666 17.5417 19.25 18.0638 19.25 18.7083C19.25 19.3529 18.4666 19.875 17.5 19.875M17.5 15.2083C18.1475 15.2083 18.7133 15.4428 19.0161 15.7917M17.5 15.2083V14.625M17.5 19.875C16.8525 19.875 16.2867 19.6405 15.9839 19.2917M17.5 19.875V20.4583",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23242 3.96484C13.6711 2.43649 18.5083 4.79576 20.0367 9.23442L20.9998 7.50183",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13443 20.0367C6.57797 19.1365 4.49486 17.0316 3.74041 14.216L2.6588 15.8773",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_47088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividendsReinvested);
export default __webpack_public_path__ + "static/media/dividendsReinvested.119336acfe0605826621d00a63bc5465.svg";
export { ForwardRef as ReactComponent };